import breakpoints from '../theme/breakpoints';
import palette from '../theme/palette';
import typography from '../theme/typography';
import { stepLabelClasses } from './StepLabel';
import { ComponentsOverrides, Theme } from '@mui/material/styles';
import pxToRem from '../theme/pxToRem';

const styleOverrides: ComponentsOverrides['MuiStepLabel'] = {
  iconContainer: {
    paddingRight: 0,
  },
  label: {
    fontSize: pxToRem(16),
    overflowWrap: 'break-word',
    color: palette.text.disabled,
    [`&, &.${stepLabelClasses.active}, &.${stepLabelClasses.completed}`]: {
      fontWeight: typography.fontWeightMedium,
    },
  },
  labelContainer: {
    [`@media only screen and (max-width: ${breakpoints.md - 0.05}px)`]: {
      display: 'none',
    },
  },
  root: ({ theme }) => ({
    [`@media only screen and (min-width: ${breakpoints.md}px)`]: {
      gap: (theme as Theme).spacing(2),
    },
  }),
};

export default styleOverrides;
